import { useMutation } from '@tanstack/react-query';
import { companiesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDeleteCompany = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id: number) =>
    companiesRepo.deleteCompany(id),
  );
